import { useAuth } from '@phx-husky/use-auth';

const useLds = () => {
    const auth = useAuth();
    return {
        validate: auth.validate,
        updateUserLegals: auth.updateUserLegals,
        getLegalsFields: auth.getLegalsFields,
        getAcceptedLegals: auth.getAcceptedLegals,
        dispatchEventIfLegalsUpdated: auth.dispatchEventIfLegalsUpdated,
    };
};

export { useLds };
